/**
 * @author      sam@zumper.com (Sam Sherman)
 * @copyright   Copyright (c) 2018, Zumper
 * @description SavedSearchOptionModal reducer
 */

import { falseReducer, nullReducer, trueReducer } from '@zcode/reducers'
import type { SavedSearchOptionModal } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import {
  DISABLE_EMAIL_NOTIFICATION,
  DISABLE_PUSH_NOTIFICATION,
  ENABLE_EMAIL_NOTIFICATION,
  ENABLE_PUSH_NOTIFICATION,
  RECEIVE_SAVED_SEARCH,
  RESET_TO_DEFAULT_STATE,
} from '../constants/savedSearchOptionModal'
import type { ActionTypes } from '../types'

export const savedSearchOptionReducer = combineReducers<SavedSearchOptionModal, ActionTypes>({
  emailNotificationEnabled: handleActions<
    SavedSearchOptionModal['emailNotificationEnabled'],
    ActionTypes
  >(
    {
      [DISABLE_EMAIL_NOTIFICATION]: falseReducer,
      [ENABLE_EMAIL_NOTIFICATION]: trueReducer,
      [RESET_TO_DEFAULT_STATE]: nullReducer,
    },
    null
  ),
  pushNotificationEnabled: handleActions<
    SavedSearchOptionModal['pushNotificationEnabled'],
    ActionTypes
  >(
    {
      [DISABLE_PUSH_NOTIFICATION]: falseReducer,
      [ENABLE_PUSH_NOTIFICATION]: trueReducer,
      [RESET_TO_DEFAULT_STATE]: nullReducer,
    },
    null
  ),
  savedSearch: handleActions<SavedSearchOptionModal['savedSearch'], ActionTypes>(
    {
      [RECEIVE_SAVED_SEARCH]: (state, action) => {
        const { payload } = action
        return payload || state
      },
      [RESET_TO_DEFAULT_STATE]: nullReducer,
    },
    null
  ),
})
